import type { DifficultyConfig, Song } from './types';
import { Stack } from 'styled-system/jsx';
import { Link } from '~/components/ui/link';
import { Table } from '~/components/ui/table';
import { Text } from '~/components/ui/text';

type Props = {
  config: DifficultyConfig;
  song: Song;
  value: number;
};

export function DifficultyCell({ config, song, value }: Props) {
  return (
    <Table.Cell
      minW="16"
      p={{ base: 0, md: 4 }}
      textAlign="center"
      bgColor={`difficulty.${config.key}.bg`}
    >
      <Link href={`/${song.id}?difficulty=${config.param}`}>
        <Stack gap="0" alignItems="center" textAlign="center">
          <Stack gap="0.5" direction="row" alignItems="baseline">
            <Text color="fg.default" fontSize="xs">
              Lv.
            </Text>
            <Text fontSize="xl" fontWeight="bold" lineHeight="1">
              {value}
            </Text>
          </Stack>
          <Text hideBelow="md" color="fg.default" fontSize="xs" lineHeight="1">
            ({song.maxCombo[config.key]})
          </Text>
        </Stack>
      </Link>
    </Table.Cell>
  );
}
